import ErrorBoundary from '../error_boundary/ErrorBoundary'
import TopBarError from '../error_boundary/error_pages/TopBarError'
import LayoutLeftNavigation from './left/LayoutLeftNavigation'
import LayoutTopBar from './LayoutTopBar'
import LayoutContent from './LayoutContent'
import Decorations from '../custom_effects/Decorations'

export default function BaseLayout() {
    return (
        <div className='base-layout'>
            <Decorations />
            <header className='layout-top-bar'>
                <ErrorBoundary renderError={() => <TopBarError />}>
                    <LayoutTopBar />
                </ErrorBoundary>
            </header>
            <div className='layout-main-canvas'>
                <ErrorBoundary>
                    <LayoutLeftNavigation />
                </ErrorBoundary>
                <LayoutContent />
            </div>
        </div>
    )
}
